import * as React from "react";
import * as ReactDOM from "react-dom";
import { useFloatingPortalNode } from "../floating-ui-react/components/FloatingPortal.js";
import { jsxs } from "react/jsx-runtime";
const FloatingPortalLite = /* @__PURE__ */ React.forwardRef(function FloatingPortalLite2(componentProps, forwardedRef) {
  const {
    children,
    container,
    className,
    render,
    style,
    ...elementProps
  } = componentProps;
  const {
    node: portalNode,
    subtree: portalSubtree
  } = useFloatingPortalNode({
    container,
    ref: forwardedRef,
    componentProps,
    elementProps
  });
  if (!portalSubtree && !portalNode) {
    return null;
  }
  return /* @__PURE__ */ jsxs(React.Fragment, {
    children: [portalSubtree, portalNode && /* @__PURE__ */ ReactDOM.createPortal(children, portalNode)]
  });
});
if (process.env.NODE_ENV !== "production") FloatingPortalLite.displayName = "FloatingPortalLite";
export {
  FloatingPortalLite
};
//# sourceMappingURL=FloatingPortalLite.js.map
